/** Limiar (px) para considerar o teclado virtual aberto. */
export const KEYBOARD_INSET_THRESHOLD_PX = 100;

export interface VisualViewportState {
  /** Altura da visual viewport (px). */
  height: number;
  /** Deslocamento do topo da visual viewport (px). */
  offsetTop: number;
  /** Altura coberta pelo teclado na base (px, nunca negativo). */
  keyboardInset: number;
  /** true quando `keyboardInset` passa do limiar. */
  isKeyboardOpen: boolean;
}

interface ComputeInput {
  innerHeight: number;
  viewportHeight: number;
  offsetTop: number;
  threshold?: number;
}

/** Deriva o estado da visual viewport a partir de medidas cruas (sem DOM). */
export function computeVisualViewportState({
  innerHeight,
  viewportHeight,
  offsetTop,
  threshold = KEYBOARD_INSET_THRESHOLD_PX,
}: ComputeInput): VisualViewportState {
  // Altura real coberta pelo teclado = base do layout viewport menos a base da
  // visual viewport = innerHeight - viewportHeight - offsetTop. O offsetTop é
  // necessário para não inflar o inset na 2ª abertura (quando o iOS rola o input
  // pra dentro da vista). A estabilidade no scroll vem de recalcular só em
  // `resize` (não em `scroll`) — ver useVisualViewport / VisualViewportBridge.
  const keyboardInset = Math.max(0, innerHeight - viewportHeight - offsetTop);
  return {
    height: viewportHeight,
    offsetTop,
    keyboardInset,
    isKeyboardOpen: keyboardInset > threshold,
  };
}
